import React from 'react';

import { useTheme } from 'styled-components';

import * as S from './styles';
import Avatar from '../../Avatar';
import StringUtil from 'domain/utils/StringUtils';
import { connectState, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateBase } from '../../../store/baseStore';


const connector = connectState(
  (state: RootStateBase) => ({
    userData: state.UtilReducer.UserData,
  })
);

type Props0 = React.HTMLAttributes<HTMLDivElement> & {
  title: string;
  subtitle: string;
  hasDropDown?: boolean;
  borderColor?: string;
  sizeImage: 'xs' | 'sm' | 'md' | 'lg',
}

interface ProfileProps extends Props0, PropsFromRedux<typeof connector> {

}

const Profile = React.forwardRef<HTMLDivElement, ProfileProps>(({
  title,
  subtitle,
  hasDropDown,
  sizeImage,
  borderColor = 'transparent',
  userData,
  dispatch,
  ...props }, forwardRef) => {
  const theme = useTheme();

  //const _userData = _UserData;

  return (
    <S.Container ref={forwardRef} {...props}>
      <Avatar
        src={userData?.ImagemUrl}
        borderColor={borderColor}
        size={sizeImage}
        alt='top'
        fallBack={StringUtil.GetFirstLetters(title)}
      />
      <S.ProfileContainer>
        <S.ProfileName>{title}</S.ProfileName>
        <S.UserRole>{subtitle}</S.UserRole>
      </S.ProfileContainer>
      {hasDropDown && (
        <S.DropdownIcon icon="mdi:arrow-down-drop" height="1.5em" color={theme.colors.text} />
      )}
    </S.Container>
  );
});

export default connector(Profile);